// extracted by mini-css-extract-plugin
export default {"spinner_wrapper":"Spinner_spinner_wrapper__WA4hA","spinner_img":"Spinner_spinner_img__NQJM4"};